import { config } from "../env";
import {
  Delete,
  get,
  patch,
  post,
  postWithSource,
} from "./helpers/http-handler";

export const adminCreateUser = (payload: object, source: string) =>
  postWithSource(`${config.API_URL}/users`, payload, source);

export const adminGetUsers = (queryRequest: string) =>
  get(`${config.API_URL}/users?${queryRequest}`);

export const adminGetSpecificUser = (id: string) =>
  get(`${config.API_URL}/users/${id}`);

export const adminUpdateSpecificUser = (id: string, payload: object) =>
  patch(`${config.API_URL}/users/${id}`, payload);

export const adminDeleteSpecificUser = (id: string) =>
  Delete(`${config.API_URL}/users/${id}`);

export const adminBulkUpdateStatus = (payload: object) =>
  patch(`${config.API_URL}/users/bulk/active-inactive`, payload);

export const adminResendInviteUsers = (payload: object) =>
  patch(`${config.API_URL}/users/bulk/resend-invite`, payload);

export const adminBulkUpdateMFAStatus = (payload: object) =>
  patch(`${config.API_URL}/users/bulk/enable-disable-mfa`, payload);

export const exportAdminUsers = () =>
  get(`${config.API_URL}/users/client/export/data`);

export const getExecutorUsers = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance-task/filters/executor?${queryRequest}`
  );

export const getEvaluatorUsers = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance-task/filters/evaluator?${queryRequest}`
  );

export const getFunctionHeadUsers = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance-task/filters/function-head?${queryRequest}`
  );

export const getATExecutorUsers = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance/filters/executor?${queryRequest}`
  );

export const getATEvaluatorUsers = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance/filters/evaluator?${queryRequest}`
  );

export const getATFunctionHeadUsers = (queryRequest: string) =>
  get(
    `${config.API_URL}/self-compliance/filters/function-head?${queryRequest}`
  );

export const getICExecutorUsers = (queryRequest: string) =>
  get(
    `${config.API_URL}/internal-compliance-task/filters/executor?${queryRequest}`
  );

export const getICEvaluatorUsers = (queryRequest: string) =>
  get(
    `${config.API_URL}/internal-compliance-task/filters/evaluator?${queryRequest}`
  );

export const getICFunctionHeadUsers = (queryRequest: string) =>
  get(
    `${config.API_URL}/internal-compliance-task/filters/function-head?${queryRequest}`
  );